import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Format a validity period as "Valid: 20 Feb 18:00 – 21 Feb 08:00 UTC"
 * Returns null if either timestamp is missing.
 */
export function formatValidityPeriod(valid_from, valid_to) {
  if (!valid_from || !valid_to) return null;
  const fmt = (d) =>
    new Date(d).toLocaleString("en-GB", {
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "UTC",
      hour12: false,
    });
  return `Valid: ${fmt(valid_from)} – ${fmt(valid_to)} UTC`;
}
